"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.DssTimeoutError = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _common = require("@webex/common");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Thrown when an expected DSS respond is not received in a timely manner.
 */
var DssTimeoutError = exports.DssTimeoutError = /*#__PURE__*/function (_Exception) {
  (0, _inherits2.default)(DssTimeoutError, _Exception);
  var _super = _createSuper(DssTimeoutError);
  /**
   * Construct DssTimeoutError
   * @param {DssTimeoutErrorParams} details
   */
  // eslint-disable-next-line no-useless-constructor
  function DssTimeoutError(details) {
    (0, _classCallCheck2.default)(this, DssTimeoutError);
    return _super.call(this, details);
  }

  /**
   * Parse Error details
   *
   * @param {DssTimeoutErrorParams} details
   * @returns {string}
   */
  (0, _createClass2.default)(DssTimeoutError, [{
    key: "parse",
    value: function parse(details) {
      return "The DSS did not respond within ".concat(details.timeout, " ms.") + "\n Request Id: ".concat(details.requestId) + "\n Resource: ".concat(details.resource) + "\n Params: ".concat((0, _stringify.default)(details.params));
    }
  }]);
  return DssTimeoutError;
}(_common.Exception);
//# sourceMappingURL=dss-errors.js.map
